import './bootstrap/bootstrap.min.js'
import './shopify/collection.js'

jQuery.noConflict()
;(function ($) {
  $(function () {
    var menu = {
      bars: $('.nav-icon'),
      overlay: $('.overlay'),
      closeBtn: $('.close-menu'),
      sbtn: $('.search-btn a'),
      init: function () {
        menu.btns()
        menu.searchForm()
      },
      btns: function () {
        menu.bars.on('click', function () {
          if ($(this).hasClass('nav-open')) {
            menu.menuClose()
          } else {
            menu.menuOpen()
          }
        })
        menu.closeBtn.on('click', function () {
          menu.menuClose()
        })
        menu.overlay.on('click', function () {
          menu.menuClose()
        })
      },
      menuOpen: function () {
        $('body').addClass('nav-open')
        menu.bars.addClass('nav-open')
      },
      menuClose: function () {
        $('body').removeClass('nav-open')
        menu.bars.removeClass('nav-open')
      },
      searchForm: function () {
        menu.sbtn.on('click', function (e) {
          e.preventDefault()
          var btn = $(this)
          if ($(this).hasClass('active')) {
            menu.closeSearch(btn)
          } else {
            menu.openSearch(btn)
          }
        })
      },
      openSearch: function (btn) {
        btn.addClass('active')
        btn.parents('.site-header-container').find('.search-wrap').slideDown()
      },
      closeSearch: function (btn) {
        btn.removeClass('active')
        btn.parents('.site-header-container').find('.search-wrap').slideUp()
      }
    }
    menu.init()

    var latest = {
      init: function () {
        if ($('body').hasClass('home')) {
          latest.click()
        }
      },
      click: function () {
        $('.latest-nav a').on('click', function (e) {
          e.preventDefault()
          var cat = $(this).data('latest')
          var btn = $(this)
          if (!$(this).hasClass('active')) {
            latest.change(btn, cat)
          }
        })
      },
      change: function (btn, cat) {
        $('.section-latest .latest-section').slideUp()
        $('.section-latest .latest-section.' + cat).slideDown()
        $('.latest-nav a').removeClass('active')
        btn.addClass('active')
      }
    }
    latest.init()

    var archive = {
      init: function () {
        if ($('body').hasClass('archive')) {
          archive.btnClick()
        }
      },
      btnClick: function () {
        $('.browse-by a.btn').on('click', function (e) {
          e.preventDefault()
          e.stopPropagation()
          if ($(this).hasClass('active')) {
            $(this).parents('.browse-by').find('.subcats').slideUp()
            $(this).removeClass('active')
          } else {
            $(this).parents('.browse-by').find('.subcats').slideDown()
            $(this).addClass('active')
          }
        })
        $(document).on('click', function () {
          $('.browse-by').find('.subcats').slideUp()
          $('.browse-by a.btn').removeClass('active')
        })
      }
    }
    archive.init()

    var links = {
      init: function () {
        links.openNew()
      },
      openNew: function () {
        $('a').each(function () {
          var a = new RegExp('/' + window.location.host + '/')
          if (!a.test(this.href)) {
            $(this).click(function (event) {
              event.preventDefault()
              event.stopPropagation()
              window.open(this.href, '_blank')
            })
          }
        })
      }
    }
    links.init()

    var s2g = {
      init: function () {
        s2g.clicks()
        //s2g.pageview();
      },
      clicks: function () {
        window.fbAsyncInit = function () {
          FB.Event.subscribe('edge.create', function () {
            s2g.gevent('facebook', 'share', window.location.pathname)
          })
          FB.Event.subscribe('message.send', function () {
            s2g.gevent('facebook', 'message', window.location.pathname)
          })
        }
      },
      pageview: function () {},
      gevent: function (category, action, label) {
        console.log('hi')
        dataLayer.push({
          event: 'GAevent',
          eventCategory: category,
          eventAction: action,
          eventLabel: label
        })
      },
      gpage: function (url, title) {
        dataLayer.push({
          event: 'VirtualPageview',
          virtualPageURL: url,
          virtualPageTitle: title
        })
      }
    }
    //s2g.init();

    var bitcoin = {
      btn: $('.bitcoin-popup'),
      init: function () {
        if (bitcoin.btn.is(':visible')) {
          bitcoin.btnClick()
        }
      },
      btnClick: function () {
        bitcoin.btn.on('click', function (e) {
          e.preventDefault()
          $(document).trigger(
            'coinbase_show_modal',
            '7b378d35d70bdeeeaa0039875159c8cd'
          )
        })
      }
    }
    bitcoin.init()
  })
})(jQuery)
